const  DashboardJobs = () =>  {
    return (
        <div className={``}>YouSchool Job</div>
    )
}

export default DashboardJobs;